import { FocusEventHandler, FunctionComponent, useState } from "react";
import useTranslate from "../translation/useTranslate";

type Props = {
    inputId: string,
    inputName: string,
    inputPLaceholder: string,
    isRequired: boolean,
    inputLabel: string,
    defaultvalue?: string,
};

type State = {
    isError: boolean,
    errorMsg: string,
};

const errMsg = {
    en: "Mandatory input",
    fr: "Ce champ est obligatoire",
};

const InputText: FunctionComponent<Props> = ({inputId, inputName, inputPLaceholder, isRequired, defaultvalue, inputLabel}) => {
    const [state, setState] = useState({} as State);
    const { getCustomTranslation } = useTranslate();

    const checkValue = (value: string): State => {
        if (value.length === 0 && isRequired) {
            return {isError: true, errorMsg: getCustomTranslation(errMsg)};
        };
        return {} as State;
    };

    const blur: FocusEventHandler<HTMLInputElement> = (e) => {
        const target = e.currentTarget;
        const value = target.value;
        const isInvalid = checkValue(value);
        setState(isInvalid);
    };


    return (
        <>
            <label htmlFor={inputId} className="inputHelp">{inputLabel} :</label>
            <input
                type="text"
                id={inputId}
                name={inputName}
                placeholder={inputPLaceholder}
                className={`input ${state.isError ? "invalid" : ""}`}
                required={isRequired || false}
                onBlur={blur}
                defaultValue={defaultvalue || ""}
            />
            {state.isError && <p className="inputError">{state.errorMsg}</p>}
        </>
    );
};

export default InputText;